// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__ZWDN2","modalForm":"UpgradeEpcsModal_modalForm__3Tse2","modalFooter":"UpgradeEpcsModal_modalFooter__2sP6P"};